import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';
import { MaterialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { reducers } from './store/reducers';
import { PillarModule } from '../pillar/pillar.module';
import { reportRoutes } from './routes.config';
import { ReportDashboardComponent } from './components/report-dashboard.component';
import { SsrsReportViewerComponent } from './components/ssrs-report-viewer.component';
import { CoreModule } from '../core/core.module';
import { ReportServiceEffects } from './services/ReportService.effects';
import { ReportService } from './services/ReportService';
import { ExtractReportViewerComponent } from './components/extract-report-viewer/extract-report-viewer.component';
import { ExtractReportServiceFactory } from './services/ExtractReportService';

@NgModule({
  entryComponents: [],
  declarations: [ReportDashboardComponent, SsrsReportViewerComponent, ExtractReportViewerComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    RouterModule.forChild(reportRoutes),
    StoreModule.forFeature('report', reducers),
    EffectsModule.forFeature([ReportServiceEffects]),
    FormsModule,
    PillarModule,
    CoreModule
  ],
  exports: [ExtractReportViewerComponent],
  providers: [ReportService, ExtractReportServiceFactory]
})
export class ReportModule {
}



// WEBPACK FOOTER //
// ./src/app/report/report.module.ts